<template>
<span
        class="switch"
        @click="toggle_switch()"
        @keydown.enter="toggle_switch()"
        @keydown.space.prevent="toggle_switch()"
        :aria-checked="modelValue?'true':'false'"
        :class="classObject"
        role="checkbox"
        tabindex="0"
        ref="switchSpan"
>
    <small></small>
    <input type="checkbox" :name="name" style="display:none"/>
    <span class="switch-text"></span>
</span>
</template>
<script>
    export default {
        name: 'VueSwitch',
        emits: ['change', 'update:modelValue'],
        props: {
            name: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                required: false
            },
            small: {
                type: Boolean,
                required: false,
                default: false
            },
            modelValue: Boolean
        },
        data() {
            return {};
        },
        computed: {
            classObject: function () {
                return {
                    checked: this.modelValue,
                    disabled: this.disabled,
                    'switch--small': this.small
                };
            }
        },
        methods: {
            toggle_switch() {
                if (this.disabled) {
                    return;
                }
                this.$emit('update:modelValue', !this.modelValue);
                this.$emit('change');
            },
            focus() {
                this.$refs.switchSpan?.focus();
            },
        },
    };
</script>
<style lang="scss" scoped>
  // in rem, so the switch grows with the label beside it; 52×30px at Default
  $switch-width: 3.25rem;
  // wider width for larger switch text
  $switch-wide-width: 5rem;
  $switch-height: 1.875rem;
  $switch-knob-offset: 1.375rem;
  // wider switch text moves the knob further to the right
  $switch-wide-knob-offset: 3.25rem;
  $switch-font-size: 0.8125rem;
  // the `small` prop halves every dimension
  $switch-small-scale: 0.8;

  // all the size-dependent rules, so a scaled-down switch keeps its proportions
  @mixin switch-size($scale: 1) {
    width: $switch-width * $scale;
    height: $switch-height * $scale;

    &.wide {
      width: $switch-wide-width * $scale;
    }

    > small {
      width: $switch-height * $scale;
      height: $switch-height * $scale;
    }

    &.checked > small {
      left: $switch-knob-offset * $scale;
    }

    &.wide.checked > small {
      left: $switch-wide-knob-offset * $scale;
    }

    .switch-text {
      font-size: $switch-font-size * $scale;
    }
  }

  .switch {
    background: var(--color-surface-heavy);
    border: 1px solid var(--color-border);
    position: relative;
    display: inline-block;
    box-sizing: content-box;
    overflow: visible;
    padding: 0;
    margin: 0;
    border-radius: 1.25rem;
    cursor: pointer;
    box-shadow: var(--color-border-strong) 0 0 0 0 inset;
    transition: 0.3s ease-out all;
    -webkit-transition: 0.3s ease-out all;
    top: -1px;

    @include switch-size;

    &.switch--small {
      @include switch-size($switch-small-scale);
    }

    > small {
      background: var(--color-switch-knob);
      border-radius: 100%;
      box-shadow: 0 0 0 1px var(--color-switch-knob-ring), 0 1px 3px var(--color-shadow-medium);
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.3s ease-out all;
      -webkit-transition: 0.3s ease-out all;
    }

    &.checked {
      background: var(--color-accent-green);
      border-color: var(--color-accent-green);

      .off {
        display: none;
      }

      .on {
        display: block;
      }
    }

    .switch-text {
      font-family: Arial, Helvetica, sans-serif;
    }

    .off {
      display: block;
      position: absolute;
      right: 10%;
      top: 25%;
      z-index: 0;
      color: var(--color-text-faint);
    }

    .on {
      display: none;
      z-index: 0;
      color: var(--color-on-fill);
      position: absolute;
      top: 25%;
      left: 9%;
    }

    &.disabled {
      opacity: .50;
      cursor: not-allowed;
    }
  }
</style>
